import Alpine from 'alpinejs';
import intersect from '@alpinejs/intersect'

import AsyncForm from './components/async-form';
import Carousel from './components/carousel';
import Countdown from './components/countdown';
import Expandable from './components/expandable';
import Gallery from './components/gallery';
import Modal from './components/modal';
import PartnersBar from './components/partners-bar';
import Slideshow from './components/slideshow';
import Timeline from './components/timeline';

Alpine.plugin(intersect)
window.Alpine = Alpine;

Alpine.data('asyncForm', AsyncForm);
Alpine.data('carousel', Carousel);
Alpine.data('countdown', Countdown);
Alpine.data('expandable', Expandable);
Alpine.data('gallery', Gallery);
Alpine.data('timeline', Timeline);
Alpine.data('modal', Modal);
Alpine.data('partnersBar', PartnersBar);
Alpine.data('slideshow', Slideshow);

Alpine.start();
